import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {createBrowserRouter, RouterProvider} from "react-router-dom"
import Work from './Pages/Work';
import Contact from './Pages/Contact';

const router = new createBrowserRouter([
  {
    path:'/',
    element:<App/>
  },
  {
    path:'/work',
    element:<Work/>
  },
  {
    path:'/contact',
    element:<Contact/>
  }
])
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* <App /> */}
     <RouterProvider router={router}/>
  </React.StrictMode>
);
